import React from "react";
import { Map } from "immutable";
import styled from "styled-components";
import { connect } from "react-redux";
import { i18n } from "../../services";
import { isMobile, mysqlDateToArabic } from "../../helpers";
import { Table } from "../../lib";
import { UD_EDITOR, UD_AUTHOR } from "../../settings";

import { fetchPages } from "../../reducers/pages/actions";
import { fetchDocUsers } from "../../reducers/doc_users/actions";

import Actions from "./Actions";
import { AppState } from "../../store";

export const Container = styled.div``;

type OwnProps = {
    doc_id: number;
    status: string;
};
const mapDispatch = {
    fetchPages,
    fetchDocUsers,
};
const mapStateToProps = (
    { user, pages, doc_users, settings }: AppState,
    { doc_id }: OwnProps
) => ({
    user,
    pages: Map<string, any>(
        // @ts-ignore
        pages.filter((p: any) => p.get("doc_id") === doc_id)
    ),
    // @ts-ignore
    doc_users: doc_users.filter((du: any) => du.get("doc_id") === doc_id),
    // @ts-ignore
    docLastOpened: settings.get("docLastOpened") as Map<number, boolean>,
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;

type Props = StateProps & DispatchProps & OwnProps;
type State = {
    selected: string[];
};

class List extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selected: [],
        };
    }

    componentDidMount() {
        const { doc_id, pages, docLastOpened } = this.props;

        if (!docLastOpened.has(doc_id) || pages.size === 0) {
            this.props.fetchPages({ doc_id });
        }

        this.props.fetchDocUsers({ doc_id });
    }

    onRowClick = (row: Record<string, string | number>) => {
        if (![UD_EDITOR, UD_AUTHOR].includes(this.props.status)) {
            return;
        }

        const id = `${row.doc_id}-${row.user_id}`;
        const { selected } = this.state;
        this.setState({ selected: selected.includes(id) ? [] : [id] });
    };

    isSelected = (row: Record<string, string | number>) =>
        this.state.selected.includes(`${row.doc_id}-${row.user_id}`);

    table() {
        const { doc_users, user } = this.props;
        let fields = ["name", "status", "updated_at"];
        let titles = ["user.name", "user.status", "form.date"];

        if (isMobile()) {
            fields = ["name", "status"];
            titles = ["user.name", "user.status"];
        }

        const transform: Record<string, (value: any) => string> = {
            updated_at: mysqlDateToArabic,
            status: (status: string) => i18n.get(`userDocForm.status${status}`),
        };

        const width = ["60%", "20%", "20%"];

        // @ts-ignore
        const user_id = user.get("id");
        const list = doc_users.toList();
        const rows = list.toJS();
        const focusedRowId = list.indexOf(
            list.find((v: any) => v.get("user_id") === user_id)
        );

        return (
            <Table
                width={width}
                titles={titles}
                fields={fields}
                transform={transform}
                rows={rows}
                focusedRowIndex={focusedRowId}
                isSelected={this.isSelected}
                onRowClick={this.onRowClick}
            />
        );
    }

    clearSelected = () => this.setState({ selected: [] });

    render() {
        const { doc_users, status, pages, doc_id, docLastOpened } = this.props;
        if (doc_users.size === 0 || pages.size === 0) {
            return null;
        }

        const { selected } = this.state;
        let selectedRow = null;
        if (selected.length > 0) {
            selectedRow = doc_users.get(selected[0]);
        }

        let lastOpened = pages.min((p: any) => p.position).get("id");
        if (docLastOpened.has(doc_id)) {
            lastOpened = docLastOpened.get(doc_id);
        }

        return (
            <Container>
                <Actions
                    status={status}
                    page_id={lastOpened}
                    doc_id={doc_id}
                    doc_users={doc_users as Map<any, any>}
                    size={doc_users.size}
                    selected={selected}
                    selectedRow={selectedRow as Map<string, string>}
                    clearSelected={this.clearSelected}
                />
                {this.table()}
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(List);
